import { render, staticRenderFns } from "./ExportCreatedBy.vue?vue&type=template&id=0c2d84a2&scoped=true"
import script from "./ExportCreatedBy.vue?vue&type=script&lang=js"
export * from "./ExportCreatedBy.vue?vue&type=script&lang=js"
import style0 from "./ExportCreatedBy.vue?vue&type=style&index=0&id=0c2d84a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d84a2",
  null
  
)

export default component.exports